export interface NavItem {
  to: string
  label: string
  icon: string // lucide icon name
  /** show in the phone bottom bar (space-limited) */
  primary?: boolean
}

export const navItems: NavItem[] = [
  { to: '/', label: 'Hjem', icon: 'house', primary: true },
  { to: '/rooms', label: 'Rom', icon: 'layout-grid', primary: true },
  { to: '/climate', label: 'Klima', icon: 'thermometer' },
  { to: '/energy', label: 'Energi', icon: 'zap', primary: true },
  { to: '/media', label: 'Media', icon: 'music' },
  { to: '/car', label: 'Bil', icon: 'car-front', primary: true },
  { to: '/security', label: 'Sikkerhet', icon: 'shield' },
  { to: '/household', label: 'Hus', icon: 'list-checks' },
  { to: '/system', label: 'System', icon: 'activity' },
]
